import { TRCFundClasses } from 'app/shared/models/tRCFundClasses.model';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { BussinessRegAppService } from 'app/service/business-reg-app/bussiness-reg-app.service';
import { TRCQGroup } from 'app/shared/models/trcQGroup.mode';
import { Answer } from 'app/shared/models/Answer.model';
import { TRCForms } from 'app/shared/models/tRCForms.model';
import { LoaderService } from 'app/service/loader/loader.service';

@Component({
  selector: 'jhi-eappreg-permit-main',
  templateUrl: './eappreg-permit-main.component.html',
  styleUrls: ['./eappreg-permit-main.component.scss']
})
export class EappregPermitMainComponent implements OnInit {


  num = 0;
  trcQGroups: TRCQGroup[];
  DispPermitGrpQuestions = false;
  permitQuestions: any = JSON.parse(sessionStorage.getItem("permitQuestions") ?? "[]")
  answers: Answer[] = [];
  tRCFundClasses: any
  loaderService :any
  
  constructor(private router: Router,
    private _businessService: BussinessRegAppService,
    private loader: LoaderService) {
      this.loaderService = this.loader
    this.trcQGroups = JSON.parse(sessionStorage.getItem("TRCQGroups") ?? "");
    this.tRCFundClasses = JSON.parse(sessionStorage.getItem("TRCFundClasses") ?? "[]");
  }

  ngOnInit(): void {
    const currentpage = sessionStorage.getItem("TRCCurrentPage");
    if (currentpage === "eappreg_questionnaire") {
      sessionStorage.setItem("TRCCurrentPage", "eappreg_permit_main")
      sessionStorage.setItem("TRCCurrGrpRow", "0")
    } else if (currentpage === "eappreg_permit_questions") {
      sessionStorage.setItem("TRCCurrentPage", "eappreg_permit_main")
      this.num = Number(sessionStorage.getItem("TRCCurrGrpRow"))
      this.num++;
      sessionStorage.setItem("TRCCurrGrpRow", String(this.num))
    } else {
      // Didn't come from right program so proceed to error page.
      this.router.navigate(['error-page'])
      return;
    }

    this.getPermitGroup();

  }

  getPermitGroup(): any {
    if (this.permitQuestions.length === 0) {
      const fundClassList = this.tRCFundClasses.map((k: TRCFundClasses) => k.revenue_type)
      const trcForms = new TRCForms()
      trcForms.trcFundClasses = fundClassList
      trcForms.trcPLCForm = JSON.parse(sessionStorage.getItem("TRCPLCForm") ?? "[]")
      trcForms.trcFREForm = JSON.parse(sessionStorage.getItem("TRCFREForm") ?? "[]")
      trcForms.trcTBCForm = JSON.parse(sessionStorage.getItem("TRCTBCForm") ?? "[]")
      this._businessService.getPermitQues(trcForms).subscribe((permitRes: any) => {
        this.permitQuestions = permitRes;
        sessionStorage.setItem("permitQuestions", JSON.stringify(permitRes))
      }, () => {/*empty*/ }, () => {
        this.jumpToNxtPage();
      })
    } else {
      this.jumpToNxtPage();
    }


  }

  jumpToNxtPage(): void {
    /* 
    this.permitQuestions hold 
    at index 0 = police permit Questionnaire
    at index 1 = fire permit Questionnaire
    at index 2 = tobacco permit Questionnaire
    */
    sessionStorage.setItem("TRCCurrGrpRow", String(this.num))
    if (this.num < 3) {
      if (this.permitQuestions[this.num].qPermitQues.length === 0) {
        if (this.num === 0) {
          sessionStorage.setItem("TRCPLCForm","[]")
        } else if (this.num === 1) {
          sessionStorage.setItem("TRCFREForm","[]")
        } else if (this.num === 2) {
          sessionStorage.setItem("TRCTBCForm","[]")
        }
        this.num++
        this.jumpToNxtPage()
        return;
      } else {
        if (this.num === 0) {
          sessionStorage.setItem("TRCPLCForm", JSON.stringify(this.permitQuestions[this.num].answers))
        } else if (this.num === 1) {
          sessionStorage.setItem("TRCFREForm", JSON.stringify(this.permitQuestions[this.num].answers))
        } else if (this.num === 2) {
          sessionStorage.setItem("TRCTBCForm", JSON.stringify(this.permitQuestions[this.num].answers))
        }
      }
      sessionStorage.setItem("qPermitQues", JSON.stringify(this.permitQuestions[this.num].qPermitQues))
      sessionStorage.setItem("TRCCurrGrpMetaName", this.permitQuestions[this.num].TRCCurrGrpMetaName)
      this.router.navigate(['eappreg_permit_questions'])
    } else {
      // sessionStorage.setItem("permitQuestions", "[]")
      this.router.navigate(['eappreg_app'])
    }
  }

}
